/* eslint-disable react/prop-types */
/* eslint-disable camelcase */

import React, { memo, useMemo } from 'react';
import Alarm from 'ui-kit/TableSizeControls/old/icons/alarm';
import * as Styled from './styles';

const RestoreAuditLogCell = ({ original, auditAction }) => {
  const handleEditClick = () => {
    const { retailer_deleted, record_id, object_type, id } = original;
    auditAction({
      deleted: retailer_deleted,
      recordId: record_id,
      objectType: object_type,
      itemId: id,
    });
  };

  const isRestored = useMemo(() => original?.action_flag === 'Deleted' && !original?.restored, [original]);

  if (!isRestored) return null;
  return (
    <Styled.CellWrapper id={original.id} onClick={handleEditClick} aria-label="Restore button">
      <Alarm />
      <Styled.Title>Restore</Styled.Title>
    </Styled.CellWrapper>
  );
};

RestoreAuditLogCell.propTypes = {};

RestoreAuditLogCell.defaultProps = {};

export default memo(RestoreAuditLogCell);
